/* eslint-disable max-lines */
import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  PERM_TYPE,
  PERSONAL,
  ProfileSelectorService,
  ProfileSelectorUtilService
} from '@com-delta-idp/mnx-capability-profile-selector-smart';
import { CompanySelection } from '@com-delta-idp/mnx-capability-profile-selector-ui';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { map } from 'rxjs/operators';
import {
  CANCEL_TRIP_CONFIRMATION_REDIRECTION,
  MFA_FLOW_FIRST_SCREEN,
  MY_TRIPS_REDIRECTION,
  RESHOP_APP_NAME,
  SHOPPING_APP_NAME
} from '../../login-modal/constants/login-constant';
import { loginAndGetDashboardResponse } from '../../login-modal/models/login-authentication-screen.interface';
import { CoreUtilService } from '../core-util.service';
import { MfaUtilService } from '../mfa-util.service';

@Injectable({
  providedIn: 'root'
})
export class NuTravelSkybonusUtilService {
  profileSelectorContentService = inject(ProfileSelectorService);
  route = inject(ActivatedRoute);
  coreUtilService = inject(CoreUtilService);
  mfaUtilService = inject(MfaUtilService);
  constructor(private profileSelectorUtilService: ProfileSelectorUtilService) {}

  setCookieFromAdmin(
    companyName: string,
    permType: string,
    accountIndex: number,
    displayInlineText: string,
    isOaSmeAccount: boolean,
    partnerId: string,
    restrictPaxToOne: boolean,
    disableMiles: boolean,
    corporateId: string
  ) {
    const companySelection: CompanySelection = {
      companyName: companyName,
      permType: permType,
      accountIndex: accountIndex,
      displayInlineText: displayInlineText,
      isOaSmeAccount: isOaSmeAccount,
      partnerId: partnerId,
      restrictOnePax: restrictPaxToOne,
      disableMiles: disableMiles,
      corporateId: corporateId
    };

    this.profileSelectorUtilService.setAccountCookie(companySelection);
    const accountType =
      permType === PERM_TYPE.B
        ? `${PERM_TYPE.B}:${accountIndex}`
        : `${PERM_TYPE.P}`;
    this.profileSelectorContentService
      .postStoreCorporateCompanyId(corporateId)
      .pipe(
        map(() =>
          this.profileSelectorContentService.postAccountTypeCall(accountType)
        )
      )
      .subscribe(() => {
        window.location.assign(window.location.origin);
      });
  }

  getQueryParamsFromAdmin() {
    this.route.queryParams.subscribe((params) => {
      const {
        fromAdmin,
        accountIndex,
        isOaSmeAccount,
        restrictPaxToOne,
        disableMiles,
        personal
      } = params;
      if (fromAdmin && !personal) {
        const companyName = atob(params.companyName);
        const partnerId = atob(params.partnerId);
        const displayInlineText = atob(params.displayInlineText);
        const corporateId = atob(params.corporateId);
        this.setCookieFromAdmin(
          companyName,
          'B',
          accountIndex,
          displayInlineText,
          this.setQueryValueToBoolean(isOaSmeAccount),
          partnerId,
          this.setQueryValueToBoolean(restrictPaxToOne),
          this.setQueryValueToBoolean(disableMiles),
          corporateId
        );
      } else {
        this.setCookieFromAdmin(
          params.companyName,
          'P',
          0,
          '',
          false,
          PERSONAL,
          false,
          false,
          ''
        );
      }
    });
  }

  setQueryValueToBoolean(value: string): boolean {
    return value === 'false' || value === '' ? false : true;
  }

  redirectToShoppingUrlAfterLoginCheck(fromApplication: string | undefined) {
    return (
      fromApplication === SHOPPING_APP_NAME ||
      fromApplication === RESHOP_APP_NAME
    );
  }

  redirectToShoppingUrlAfterLogin(
    fromApplication: string | undefined,
    redirectUrl: string | undefined
  ) {
    //TODO: remove if condition to make redirection work without appName
    if (this.redirectToShoppingUrlAfterLoginCheck(fromApplication)) {
      if (redirectUrl && redirectUrl !== '') {
        window.location.replace(redirectUrl);
        return true;
      }
    }
    return false;
  }

  redirectUserToRefreshUrlHelper(
    pageUrl: string | undefined,
    authenticationConfig: OauthAEMConfig | undefined,
    response?: loginAndGetDashboardResponse,
    tokenResponse?: string
  ) {
    this.mfaUtilService.timeStampExpiry(authenticationConfig);
    if (pageUrl) {
      if (
        this.mfaUtilService.validateMFARedirection(
          authenticationConfig,
          response
        ) &&
        this.coreUtilService.redirectToMfa(response, tokenResponse)
      ) {
        window.location.assign(
          `${MFA_FLOW_FIRST_SCREEN}?refreshURL=${pageUrl}`
        );
      } else {
        window.location.assign(pageUrl);
      }
    }
  }

  redirectUserToRefreshUrl(
    fromApplication: string | undefined,
    redirectUrl: string | undefined,
    refreshUrl: string | undefined,
    authenticationConfig: OauthAEMConfig | undefined,
    response?: loginAndGetDashboardResponse,
    tokenResponse?: string
  ): void {
    if (this.redirectToShoppingUrlAfterLogin(fromApplication, redirectUrl)) {
      return;
    }
    const pageUrl = refreshUrl?.includes(CANCEL_TRIP_CONFIRMATION_REDIRECTION)
      ? MY_TRIPS_REDIRECTION
      : redirectUrl
      ? redirectUrl
      : refreshUrl;
    this.redirectUserToRefreshUrlHelper(
      pageUrl,
      authenticationConfig,
      response,
      tokenResponse
    );
  }
}
